export default __webpack_public_path__ + "static/media/filling_9.89492202.webp";